import { DateTime } from 'luxon';
import { BookingCompressed, ResourceCompressed } from '@jooxter/api';
import { IRange } from '@jooxter/utils';
import { Dispatch, SetStateAction } from 'react';

export enum OverlapResolutionActionEnum {
  Delete = 'DELETE',
  Truncate = 'TRUNCATE',
  Move = 'MOVE',
}

export interface IJxtOverlapResolutionModal {
  show: boolean;
  bookings: BookingCompressed[];
  // Both required for the "Move" choice to be offered (it needs a resource to move onto and a
  // handler to act on it) - when either is omitted, only Delete/Truncate are shown.
  newResource?: ResourceCompressed;
  allowMove: boolean;
  newRange: IRange;
  actions: Map<number, OverlapResolutionActionEnum>;
  onChange: Dispatch<SetStateAction<Map<number, OverlapResolutionActionEnum>>>;
  onConfirm: () => void;
  onHide: () => void;
  // True while the full record of at least one overlapping booking is still being fetched - disables
  // Confirm so a Truncate choice can't be confirmed before there's a payload to send it with.
  isLoading?: boolean;
  // True when at least one conflicting booking has neither cancel nor update capability - none of
  // Delete/Truncate/Move can be committed for it, so Confirm is disabled entirely rather than
  // letting the user confirm a resolution that can't actually be carried out for that booking.
  hasUnresolvableBooking?: boolean;
  // Injectable for tests; defaults to the real current time. Used to grey out Truncate when the
  // resulting remainder would already be in the past (e.g. an already-started booking).
  now?: DateTime;
}

export interface IOverlapPartitionResult {
  toDelete: number[];
  toTruncate: { booking: BookingCompressed; range: IRange }[];
  toMove?: BookingCompressed;
}
